import PropTypes from 'prop-types';
import React from 'react';
import OptimizelyProvider from './context/OptimizelyProvider';
import { getEnv } from '../environment';
import { Banner } from './components/Banners/Banner';
import NMFHeader from './components/Header/NMFHeader';
import GlobalNavContext from './context/globalNavContext';

const NewMemberNavTemplate = ({ env, step, setRedirectLoading = () => {} }) => (
  <React.StrictMode>
    <OptimizelyProvider>
      {/* TODO: add use memo hook for pass this value*/}
      {/*eslint-disable-next-line react/jsx-no-constructed-context-values*/}
      <GlobalNavContext.Provider value={{ env: getEnv(env) }}>
        <Banner />
        <NMFHeader
          env={env}
          step={step}
          showDetailed
          setRedirectLoading={setRedirectLoading}
        />
      </GlobalNavContext.Provider>
    </OptimizelyProvider>
  </React.StrictMode>
);

NewMemberNavTemplate.propTypes = {
  env: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
};

export default React.memo(NewMemberNavTemplate);
